export async function preloadImages (urls) {
    return new Promise((resolve, reject) => {
        let loadedCounter = 0;
        const toBeLoadedNumber = urls.length;

        urls.forEach(function (url) {
            preloadImage(url, function () {
              loadedCounter++;
              if (loadedCounter === toBeLoadedNumber) {
                  resolve();
              }
            });
        });

        function preloadImage (url, anImageLoadedCallback) {
            const img = new Image();
            img.src = url;
            img.onload = anImageLoadedCallback;
        }
    });
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/preload-images.ts